module.exports = "/img/hand.7cc80512.png";